var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"options",class:_vm.className},[(_vm.search)?_c('mdb-input',{staticClass:"search mx-2",attrs:{"placeholder":_vm.searchPlaceholder},on:{"input":_vm.searchValue}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }